import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CEProductCustomizationPreview } from '../../bitf-customization-engine/CEProductCustomizationPreview';

const INIT_CLASS = 'initialized';
const reactRoots = new Map();

const cleanupRemovedElements = () => {
  for (const [element, root] of reactRoots.entries()) {
    if (!document.contains(element)) {
      root.unmount();
      reactRoots.delete(element);
    }
  }
};

const initPreviewApps = () => {
  cleanupRemovedElements();

  const productDataElements = document.querySelectorAll(
    `.collection__main .product-customization-preview:not(.${INIT_CLASS}), .product-gallery .product-customization-preview:not(.${INIT_CLASS}), .product-customization-drawer__product-preview .product-customization-preview:not(.${INIT_CLASS})`,
  );

  productDataElements.forEach((element) => {
    const productHandle = element.getAttribute('data-product-handle');
    const productType = (element.getAttribute('data-product-type') || 'jersey').toLowerCase();
    const playerHandle = element.getAttribute('data-player-handle');
    const competitionHandle = element.getAttribute('data-competition-handle');
    const storeName = element.getAttribute('data-store-name') || 'shared';
    const watchStoreChanges = element.getAttribute('data-watch-store-changes') === 'true';
    const country = element.getAttribute('data-country');
    const language = element.getAttribute('data-language');
    const market = element.getAttribute('data-market');
    const isAlwaysVisible = element.getAttribute('data-is-always-visible') === 'true';
    const showProductImage = element.getAttribute('data-show-product-image') === 'true';
    let productVariant = element.getAttribute('data-product-variant');

    try {
      productVariant = productVariant ? JSON.parse(productVariant) : null;
    } catch (error) {
      productVariant = null;
    }

    element.classList.add(INIT_CLASS);

    const root = createRoot(element);
    reactRoots.set(element, root);

    root.render(
      <StrictMode>
        <CEProductCustomizationPreview
          productHandle={productHandle}
          productType={productType}
          playerHandle={playerHandle}
          competitionHandle={competitionHandle}
          customizationHookConfig={{ storeName, watchStoreChanges, country, language, market }}
          isAlwaysVisible={isAlwaysVisible}
          showProductImage={showProductImage}
          productVariant={productVariant}
        />
      </StrictMode>,
    );
  });
};

document.addEventListener('collection:load-products', (event) => {
  initPreviewApps();
});

initPreviewApps();
